import apiClient from './apiClient';

export async function listRefPartyTelegramSettings() {
  const res = await apiClient.get('/ref-party-telegram');
  return res.data.data.items;
}

export async function upsertRefPartyTelegramSetting(name, telegramChatId) {
  const res = await apiClient.post('/ref-party-telegram', { name, telegramChatId });
  return res.data.data;
}

export async function removeRefPartyTelegramSetting(refPartyId) {
  const res = await apiClient.delete(`/ref-party-telegram/${refPartyId}`);
  return res.data.data;
}

export async function notifyNowRefParty(refPartyId) {
  const res = await apiClient.post(`/ref-party-telegram/${refPartyId}/notify-now`);
  return res.data.data;
}

export async function setSalesReportEnabled(refPartyId, enabled) {
  const res = await apiClient.post(`/ref-party-telegram/${refPartyId}/sales-report-enabled`, { enabled });
  return res.data.data;
}

export async function setReorderReportEnabled(refPartyId, enabled) {
  const res = await apiClient.post(`/ref-party-telegram/${refPartyId}/reorder-report-enabled`, { enabled });
  return res.data.data;
}

export async function setInactiveDigestEnabled(refPartyId, enabled) {
  const res = await apiClient.post(`/ref-party-telegram/${refPartyId}/inactive-digest-enabled`, { enabled });
  return res.data.data;
}

// DAILY-UI v1
export async function setDailyActionEnabled(refPartyId, enabled) {
  const res = await apiClient.post(`/ref-party-telegram/${refPartyId}/daily-action-enabled`, { enabled });
  return res.data.data;
}

export async function dailyActionTest(refPartyId) {
  const res = await apiClient.post(`/ref-party-telegram/${refPartyId}/daily-action-test`);
  return res.data.data;
}
